import { render } from "./Repair_delete_button.vue?vue&type=template&id=f470f190&scoped=true"
import script from "./Repair_delete_button.vue?vue&type=script&lang=js"
export * from "./Repair_delete_button.vue?vue&type=script&lang=js"

import "./Repair_delete_button.vue?vue&type=style&index=0&id=f470f190&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f470f190"]])

export default __exports__